import MonitoringInterfaceV1 from './MonitoringInterfaceV1';
import { getServices } from '../../../infra/startup';
import { SpanType } from '../../../services/monitoringService/types';
import { MonitoringInterfaceV1Type } from './types';
import { internalLogger } from '../clientOsLogger';

let monitoringInterfaceV1: MonitoringInterfaceV1;

function _createMonitoringInterfaceV1() {
  const services = getServices();
  const { monitoringService } = services;

  return new MonitoringInterfaceV1({
    monitoringService
  });
}

export function getMonitoringInterfaceV1(): MonitoringInterfaceV1 {
  return monitoringInterfaceV1;
}

export default async function initializeMonitoringInterfaceV1(): Promise<MonitoringInterfaceV1Type> {
  if (monitoringInterfaceV1) return monitoringInterfaceV1.getInterface();
  monitoringInterfaceV1 = _createMonitoringInterfaceV1();

  return monitoringInterfaceV1.getInterface();
}

export function createNoopMonitoringInterfaceV1(): MonitoringInterfaceV1Type {
  return {
    getSessionId: function (): string {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopMonitoringInterfaceV1',
        methodName: 'getSessionId()',
        message: 'Noop interface method called - returning empty string'
      });
      return '';
    },
    startSpan: function (): SpanType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopMonitoringInterfaceV1',
        methodName: 'startSpan()',
        message: 'Noop interface method called - returning empty span object'
      });
      return { end: () => {} };
    }
  };
}
